import { DropdownButton } from 'ca-ui';

export class InterestRegions extends DropdownButton {
    static defaultOptions = {
      componentName: 'InterestRegions',
      icon: 'smile',
      dropDown: {
        width: 'auto',
        maxHeight: 600
      }
    };

    constructor (options, editor, vr, panel) {
      super(InterestRegions.initOptions($.extend({}, InterestRegions.defaultOptions, options)));
      this.vr = vr;
      this.editor = editor;
      this.panel = panel;
      this.isRegionDetailPanelOpen = false;
      this.isUtilityControlsVisible = true;

      this.initControls();
      this.displayRegions();

      // region var
      if (!vr.options.interestRegions) {
        this.regionsToSave = null;
      }

      this.currentRegionEditing = null;
      this.selectedHotspots = null;

      if (vr.options.interestRegions) {
        console.log(vr.options.interestRegions);
      }
    }

    initControls () {
      this.panelContainer = $('<div class=\'ca-ver_editor_interest-regions\'></div>');
      this.dropDown.add(this.panelContainer);

      this.regionListPanel = $('<div class=\'ca-ver_editor_interest-regions_list-panel\'></div>');
      this.panelContainer.append(this.regionListPanel);

      this.heading = $('<div class=\'ca-ver_editor_interest-regions_list-panel-heading\'>Interest Regions</div>');
      this.regionListPanel.append(this.heading);

      this.regionContainer = $('<div class=\'ca-ver_editor_interest-regions_region-container\'></div>');
      this.regionListPanel.append(this.regionContainer);

      this.regionContainerText = $('<div class=\'ca-ver_editor_interest-regions_region-container-text\'></div>');
      this.regionContainer.append(this.regionContainerText);

      this.regionContainerList = $('<ul class=\'ca-ver_editor_interest-regions_region-container-list\'></ul>');
      this.regionContainer.append(this.regionContainerList);
      this.regionContainerList.hide();

      this.regionUtilityControls = $('<div class=\'ca-ver_editor_interest-regions_region-utility-controls\'></div>');
      this.panelContainer.append(this.regionUtilityControls);

      this.addRegionButton = $('<button class=\'ca-ver_editor_interest-regions_region-utility-controls_add\'><i class=\'fas fa-plus\'></i></button>');
      this.regionUtilityControls.append(this.addRegionButton);

      this.addRegionButton.on('click', function () {
        this.addRegion();
        this.triggerRegionDetailPanel();
        this.triggerUtilityControls();
      }.bind(this));

      this.editRegionButton = $('<button disabled class=\'ca-ver_editor_interest-regions_region-utility-controls_edit\'><i class=\'fas fa-pencil\'></i></button>');
      this.regionUtilityControls.append(this.editRegionButton);

      this.editRegionButton.on('click', function () {
        this.editRegion();
        this.triggerRegionDetailPanel();
        this.triggerUtilityControls();
      }.bind(this));

      this.removeRegionButton = $('<button disabled class="ca-ver_editor_interest-regions_region-utility-controls_remove"><i class=\'fas fa-times\'></i></button>');
      this.regionUtilityControls.append(this.removeRegionButton);

      this.removeRegionButton.on('click', function () {
        this.removeRegion();
      }.bind(this));

      // probably want to spawn the side panel and popuplate it here as well
      this.editRegionPanel = $('<div class=\'ca-ver_editor_interest-regions_edit-region-panel\'></div>');
      this.panelContainer.append(this.editRegionPanel);

      this.editRegionHeading = $('<div class=\'ca-ver_editor_interest-regions_edit-region-heading\'>Edit Interest Region</div>');
      this.editRegionPanel.append(this.editRegionHeading);

      this.editRegionNameLabel = $('<label for=\'regionName\'>Interest Region Name</label>');
      this.editRegionPanel.append(this.editRegionNameLabel);

      this.editRegionNameInput = $('<input type=\'text\' id=\'regionName\' name=\'regionName\'>');
      this.editRegionPanel.append(this.editRegionNameInput);

      this.editRegionNameInput.on('change', function () {
        this.setRegionName(this.editRegionNameInput.val());
      }.bind(this));

      this.editRegionHotspotHeading = $('<div class=\'ca-ver_editor_interest-regions_edit-region-hotspot-heading\'>Currently Set Hotspots</div>');
      this.editRegionPanel.append(this.editRegionHotspotHeading);

      this.editRegionHotspotContainer = $('<div class=\'ca-ver_editor_interest-regions_edit-region-hotspot-container\'></div>');
      this.editRegionPanel.append(this.editRegionHotspotContainer);

      this.editRegionHotspotList = $('<ul class=\'ca-ver_editor_interest-regions_edit-region-hotspot-list-container\'></div>');
      this.editRegionHotspotContainer.append(this.editRegionHotspotList);

      this.editRegionErrorMessage = $('<div class=\'ca-ver_editor_interest-regions_edit-region_error\'></div>');
      this.editRegionPanel.append(this.editRegionErrorMessage);
      this.editRegionErrorMessage.hide();

      this.editRegionHotspotControls = $('<div class=\'ca-ver_editor_interest-regions_edit-region-hotspot-controls\'></div>');
      this.editRegionHotspotContainer.append(this.editRegionHotspotControls);

      this.editRegionOpenHotspotListButton = $('<button><i class=\'fas fa-plus\'></i></button>');
      this.editRegionHotspotControls.append(this.editRegionOpenHotspotListButton);

      this.editRegionOpenHotspotListButton.on('click', function () {
        this.triggerHotspotListPanel();
      }.bind(this));

      this.editRegionRemoveHotspotButton = $('<button disabled><i class=\'fas fa-times\'></i></button>');
      this.editRegionHotspotControls.append(this.editRegionRemoveHotspotButton);

      this.editRegionRemoveHotspotButton.on('click', function () {
        this.removeHotspotFromRegion();
      }.bind(this));

      this.editRegionButtonContainer = $('<div class=\'ca-ver_editor_interest-regions_edit-region-button-container\'></div>');
      this.editRegionPanel.append(this.editRegionButtonContainer);

      this.editRegionCaptureViewButton = $('<button class=\'ca-ver_editor_interest-regions_edit-region_button\'>Capture Current Location</button>');
      this.editRegionButtonContainer.append(this.editRegionCaptureViewButton);

      this.editRegionCaptureViewButton.on('click', function () {
        this.captureCurrentView();
      }.bind(this));

      this.editRegionSaveButton = $('<button class=\'ca-ver_editor_interest-regions_edit-region_button\'>Save Interest Region</button>');
      this.editRegionButtonContainer.append(this.editRegionSaveButton);

      this.editRegionSaveButton.on('click', function () {
        this.saveRegionDetails();
      }.bind(this));

      this.editRegionCancelButton = $('<button class=\'ca-ver_editor_interest-regions_edit-region_button\'>Cancel Editing Region</button>');
      this.editRegionButtonContainer.append(this.editRegionCancelButton);

      this.editRegionCancelButton.on('click', function () {
        this.cancelRegionDetails();
      }.bind(this));

      // save and close button
      this.saveAndCloseButton = $('<button>Save all Regions and Close</button>');
      this.dropDown.add(this.saveAndCloseButton);

      this.saveAndCloseButton.on('click', function () {
        this.closeAndSaveRegions();
      }.bind(this));

      this.cancelAndCloseButton = $('<button>Cancel all changes and Close</button>');
      this.dropDown.add(this.cancelAndCloseButton);

      this.cancelAndCloseButton.on('click', function () {
        this.cancelAndCloseEditing();
      }.bind(this));

      // hotspot list panel
      this.hotspotListPanel = $('<div class=\'ca-ver_editor_interest_regions_hotspot-list-panel\'></div>');
      this.panelContainer.append(this.hotspotListPanel);

      this.hotspotListHeading = $('<div class=\'ca-ver_editor_interest_regions_hotspot-list-heading\'>Currently Available Hotspots</div>');
      this.hotspotListPanel.append(this.hotspotListHeading);

      this.hotspotList = $('<ul class="ca-ver_editor_interest_regions_hotspot-list"></ul>');
      this.hotspotListPanel.append(this.hotspotList);

      this.hotspotListPanelButtonGroup = $('<div class="ca-ver_editor_interest_regions_hotspot-list_buttons"></div>');
      this.hotspotListPanel.append(this.hotspotListPanelButtonGroup);

      this.cancelHotspotAdditionButton = $('<button>Cancel Hotspot Additions</button>');
      this.hotspotListPanelButtonGroup.append(this.cancelHotspotAdditionButton);

      this.cancelHotspotAdditionButton.on('click', function () {
        this.cancelHotspotAddition();
      }.bind(this));

      this.addSelectedHotspotsButton = $('<button>Add Selected Hotspots to Region</button>');
      this.hotspotListPanelButtonGroup.append(this.addSelectedHotspotsButton);

      this.addSelectedHotspotsButton.on('click', function () {
        this.addHotspotsToRegion();
      }.bind(this));
    }

    displayRegions () {
      // we need to see if there are any regions in our scene
      if (this.vr.options.interestRegions === undefined) {
        this.regionContainerText.text('No Interest Regions set in this room.');
      } else if (this.vr.options.interestRegions === null) {
        this.regionContainerText.text('No Interest Regions set in this room.');
      } else {
        this.regionsToSave = this.vr.options.interestRegions;
        this.regionContainerText.hide();
        this.generateInterestRegionEntries();
        console.log(this.regionsToSave);
      }
    }

    addRegion () {
      console.log('add region');
      this.currentRegionEditing = {
        id: this.regionsToSave ? this.regionsToSave.length : 0,
        name: null,
        location: null,
        hotspots: null,
        order: null
      };
      this.clearInputFields();
    }

    editRegion () {
      console.log('edit region');
      this.currentRegionEditing = {
        id: this.selected.id,
        name: this.selected.name,
        location: this.selected.location,
        hotspots: this.selected.hotspots,
        order: this.selected.order
      };

      this.populateInputFields();
    }

    removeRegion () {
      console.log('remove region');
      console.log(this.regionsToSave);
      const index = this.regionsToSave.indexOf(this.selected);
      if (index > -1) {
        this.regionsToSave.splice(index, 1);
        this.generateInterestRegionEntries();
      }

      if (this.regionsToSave.length === 0) {
        this.regionsToSave = null;
        this.regionContainerText.show();
        this.regionContainerText.text('No Interest Regions set in this room.');
      }
      console.log(this.regionsToSave);
    }

    triggerRegionDetailPanel () {
      console.log('open region detail panel');
      this.isRegionDetailPanelOpen = !this.isRegionDetailPanelOpen;
      if (this.isRegionDetailPanelOpen) {
        this.editRegionPanel.addClass('open');
        this.panelContainer.addClass('detail-open');
      } else {
        this.editRegionPanel.removeClass('open');
        this.panelContainer.removeClass('detail-open');
      }
    }

    triggerUtilityControls () {
      this.isUtilityControlsVisible = !this.isUtilityControlsVisible;
      if (this.isUtilityControlsVisible) {
        this.regionUtilityControls.show();
      } else {
        this.regionUtilityControls.hide();
      }
    }

    triggerHotspotListPanel () {
      console.log('trigger hotspot list panel');
      this.isAvailableHotspotListPanelOpen = !this.isAvailableHotspotListPanelOpen;
      if (this.isAvailableHotspotListPanelOpen) {
        this.generateHotspotEntries();
        this.hotspotListPanel.addClass('open');
        this.panelContainer.removeClass('detail-open');
        this.panelContainer.addClass('detail-hotspot-open');
      } else {
        this.hotspotListPanel.removeClass('open');
        this.panelContainer.removeClass('detail-hotspot-open');
        this.panelContainer.addClass('detail-open');
      }
    }

    captureCurrentView () {
      console.log('capture the pitch and yaw of the current view');
      const pitch = this.vr.panoViewer.getPitch();
      const yaw = this.vr.panoViewer.getYaw();
      this.currentRegionEditing.location = {
        pitch: pitch,
        yaw: yaw
      };
      this.editRegionCaptureViewButton.text('Captured Location!');
      setTimeout(function () {
        this.editRegionCaptureViewButton.text('Capture Current Location');
      }.bind(this), 2000);
    }

    addHotspotsToRegion () {
      console.log('add the selected hotspot to the current region');
      this.currentRegionEditing.hotspots = this.selectedHotspots;
      this.selectedHotspots = null;
      this.triggerHotspotListPanel();
      this.generateHotspotListInRegionEditor();
      console.log(this.currentRegionEditing);
    }

    removeHotspotFromRegion () {
      console.log('remove the selected hotspot from the currently edited region');
      const index = this.currentRegionEditing.hotspots.indexOf(this.selectedHotspotInRegion);
      if (index > -1) {
        this.currentRegionEditing.hotspots.splice(index, 1);
        this.generateHotspotListInRegionEditor();
      }
    }

    cancelHotspotAddition () {
      console.log('cancel hotspot addition');
      this.selectedHotspots = null;
      this.triggerHotspotListPanel();
      this.clearHotspotEntries();
    }

    cancelRegionDetails () {
      console.log('cancel region details');
      this.currentRegionEditing = null;
      this.triggerRegionDetailPanel();
      this.triggerUtilityControls();
    }

    saveRegionDetails () {
      console.log('save region details and trigger region detail panel');
      if (this.currentRegionEditing.name !== null && this.currentRegionEditing.location !== null) {
        console.log('we can save and add to the list of regions to save');
        console.log('we can also close this panel');
        this.editRegionErrorMessage.hide();
        if (this.regionsToSave === null) {
          this.regionsToSave = [];
        }
        // check to see if this already exists in this.regionsToSave
        console.log('lets see if theres something here');
        console.log(this.currentRegionEditing.id);
        console.log(this.regionsToSave[this.currentRegionEditing.id]);
        if (this.regionsToSave[this.currentRegionEditing.id]) {
          console.log('this already exists and we need to apply the changes to that specific entry');
          this.regionsToSave[this.currentRegionEditing.id] = {
            hotspots: this.currentRegionEditing.hotspots,
            id: this.currentRegionEditing.id,
            location: this.currentRegionEditing.location,
            name: this.currentRegionEditing.name,
            order: this.currentRegionEditing.order
          };
        } else {
          this.regionsToSave.push(this.currentRegionEditing);
        }

        this.triggerRegionDetailPanel();
        this.triggerUtilityControls();
        this.updateRegionList();
      } else if (this.currentRegionEditing.name === null && this.currentRegionEditing.location === null) {
        // we need to change the alert message and show it
        this.editRegionErrorMessage.text('Cannot save until you have a Name AND Location set.');
        this.editRegionErrorMessage.show();
      } else if (this.currentRegionEditing.name === null) {
        this.editRegionErrorMessage.text('Cannot save until you have a Region Name set.');
        this.editRegionErrorMessage.show();
      } else if (this.currentRegionEditing.location === null) {
        this.editRegionErrorMessage.text('Cannot save until you have a Region Location set.');
        this.editRegionErrorMessage.show();
      }

      console.log(this.regionsToSave);
    }

    closeAndSaveRegions () {
      console.log('close panel and save all categories/regions to scene options');
      if (this.vr.options.interestRegions === null) {
        this.vr.options.interestRegions = [];
      }

      this.vr.options.interestRegions = this.regionsToSave;
      this.dropDown.hide();
      $(this.vr.topBarInterestRegionsMenu).empty();
      this.vr.addTopBarInterestRegionMenu();
    }

    cancelAndCloseEditing () {
      console.log('cancel all changes and close interest regions editor');
      this.regionsToSave = null;
      this.dropDown.hide();
    }

    // generate interest region entries
    generateInterestRegionEntries () {
      console.log('generate interest region entries');
      this.regionContainerList.empty();
      if (this.regionsToSave) {
        if (this.regionsToSave.length > 0) {
          this.regionContainerText.hide();
          this.regionContainerList.show();
          for (let i = 0; i < this.regionsToSave.length; i++) {
            const entry = this.regionsToSave[i];
            console.log(entry);
            // create an li wrapping an a
            const entryToAdd = $(`<li class='ca-ver_editor_interest-regions_region-container-list-entry'>${entry.hotspots !== null ? '<i class="fas fa-caret-right"></i>' : ''}<a>${entry.name}</a></li>`);
            entryToAdd.on('click', function (el) {
              this.selectRegionEntry(entry, el);
            }.bind(this));
            this.regionContainerList.append(entryToAdd);
          }
        }
      } else if (this.vr.options.interestRegions) {
        if (this.vr.options.interestRegions.length > 0) {
          this.regionContainerText.hide();
          this.regionContainerList.show();
          for (let i = 0; i < this.vr.options.interestRegions.length; i++) {
            const entry = this.vr.options.interestRegions[i];
            console.log(entry);
            // create an li wrapping an a
            const entryToAdd = $(`<li class='ca-ver_editor_interest-regions_region-container-list-entry'>${entry.hotspots !== null ? '<i class="fas fa-caret-right"></i>' : ''}<a>${entry.name}</a></li>`);
            entryToAdd.on('click', function (el) {
              this.selectRegionEntry(entry, el);
            }.bind(this));
            this.regionContainerList.append(entryToAdd);
          }
        }
      }
    }

    generateHotspotEntries () {
      console.log('generate hotspot entries');
      this.hotspotList.empty();
      if (this.selectedHotspots === null) {
        this.selectedHotspots = [];
      }
      if (this.vr.scene.hotspots && this.vr.scene.hotspots.length > 0) {
        console.log(this.vr.scene.hotspots);
        for (let i = 0; i < this.vr.scene.hotspots.length; i++) {
          const entry = this.vr.scene.hotspots[i];
          console.log(entry);

          if (this.currentRegionEditing.hotspots !== null) {
            const index = this.currentRegionEditing.hotspots.indexOf(entry);
            if (index > -1) {
              continue;
            }
          }

          const entryToAdd = $(`<li class='ca-ver_editor_interest_regions_hotspot-list-entry'><a>${entry.options.tooltip.label !== null ? entry.options.tooltip.label : entry.id}</a></li>`);
          entryToAdd.on('click', function (el) {
            this.selectHotspotEntry(entry, el);
          }.bind(this));
          this.hotspotList.append(entryToAdd);
        }
      }
    }

    generateHotspotListInRegionEditor () {
      console.log('regenerate hotspot list of region were currently editing');
      this.editRegionHotspotList.empty();
      if (this.currentRegionEditing.hotspots !== null) {
        for (let i = 0; i < this.currentRegionEditing.hotspots.length; i++) {
          const entry = this.currentRegionEditing.hotspots[i];
          console.log(entry);

          const entryToAdd = $(`<li class='ca-ver_editor_interest-regions_edit-region-hotspot-list-container-entry'><a>${entry.name}</a></li>`);
          entryToAdd.on('click', function (el) {
            this.selectHotspotEntryInRegionEditor(entry, el);
          }.bind(this));
          this.editRegionHotspotList.append(entryToAdd);
        }
      }
    }

    clearHotspotEntries () {
      this.hotspotList.empty();
    }

    setRegionName (_name) {
      this.currentRegionEditing.name = _name;
    }

    selectRegionEntry (_region, _element) {
      console.log('region selected');
      console.log($(_element));
      if ($(_element.currentTarget).hasClass('selected')) {
        console.log('is already selected, deselect entry');
        this.selected = null;
        $(_element.currentTarget).removeClass('selected');
        this.editRegionButton.prop('disabled', true);
        this.removeRegionButton.prop('disabled', true);
      } else {
        console.log('does not have class, add selected');
        // TODO: will have to unset selected on ALL other lis
        $('.ca-ver_editor_interest-regions_region-container-list-entry').removeClass('selected');
        $(_element.currentTarget).addClass('selected');
        this.selected = _region;
        this.editRegionButton.prop('disabled', false);
        this.removeRegionButton.prop('disabled', false);
      }
    }

    selectHotspotEntry (_hotspot, _element) {
      console.log('select this hotspot');
      if ($(_element.currentTarget).hasClass('selected')) {
        console.log('deselect this');
        const index = this.selectedHotspots.indexOf(_hotspot);
        if (index > -1) {
          this.selectedHotspots.splice(index, 1);
        }
        $(_element.currentTarget).removeClass('selected');
      } else {
        $(_element.currentTarget).addClass('selected');

        const hotspotName = _hotspot.options.tooltip.label ? _hotspot.options.tooltip.label : _hotspot.id;
        const hotspotPitch = _hotspot.options.pitch;
        const hotspotYaw = _hotspot.options.yaw;
        const hotspotIcon = _hotspot.options.icon;
        const hotspotId = _hotspot.id;
        this.selectedHotspots.push({
          name: hotspotName,
          pitch: hotspotPitch,
          yaw: hotspotYaw,
          icon: hotspotIcon,
          id: hotspotId
        });
      }

      console.log(this.selectedHotspots);
    }

    selectHotspotEntryInRegionEditor (_hotspot, _element) {
      console.log('select hotspot in region editor');
      if ($(_element.currentTarget).hasClass('selected')) {
        this.selectedHotspotInRegion = null;
        $(_element.currentTarget).removeClass('selected');
        this.editRegionRemoveHotspotButton.prop('disabled', true);
      } else {
        $('.ca-ver_editor_interest-regions_edit-region-hotspot-list-container-entry').removeClass('selected');
        $(_element.currentTarget).addClass('selected');
        this.selectedHotspotInRegion = _hotspot;
        this.editRegionRemoveHotspotButton.prop('disabled', false);
      }
    }

    updateRegionList () {
      this.generateInterestRegionEntries();
    }

    clearInputFields () {
      // more to come here
      this.editRegionNameInput.val('');
    }

    populateInputFields () {
      this.editRegionNameInput.val(this.currentRegionEditing.name);
      // more to come with hotspots
      this.generateHotspotListInRegionEditor();
    }

    static initOptions (options) {
      options.button = {
        label: 'Configure',
        icon: options.icon
      };
      return options;
    }
}
